var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chat",
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.607,
    height: 82.136,
    viewBox: "0 0 87.607 82.136",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M64.508,15.988H7.7a7.708,7.708,0,0,0-7.7,7.7V64.754a7.707,7.707,0,0,0,7.7,7.7h7.7V85.287A2.569,2.569,0,0,0,19.78,87.1c7.166-7.168,2.134-2.134,13.9-13.9a2.563,2.563,0,0,1,1.815-.753H64.508a7.708,7.708,0,0,0,7.7-7.7V23.688A7.709,7.709,0,0,0,64.508,15.988Zm-51.675,15.4H49.108a2.567,2.567,0,1,1,0,5.133H12.833a2.567,2.567,0,0,1,0-5.133ZM38.842,57.054H12.833a2.567,2.567,0,1,1,0-5.133H38.842a2.567,2.567,0,1,1,0,5.133ZM59.375,46.788H12.833a2.567,2.567,0,1,1,0-5.133H59.375a2.567,2.567,0,1,1,0,5.133Z",
    transform: "translate(0 -15.988)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(31.421 10.267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M232.118,75.989h-2.532v38.5a12.878,12.878,0,0,1-12.867,12.833H189.106l-5.475,5.1h21.758L220.036,147.1a2.567,2.567,0,0,0,4.381-1.815V132.421h7.7a7.679,7.679,0,0,0,7.7-7.666V83.689A7.708,7.708,0,0,0,232.118,75.989Z",
    transform: "translate(-183.631 -75.989)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.340b5f00ff14990963d35b3fede4e90d.svg";
export { ForwardRef as ReactComponent };